import React from 'react';
import Parent from '../../common/parent';
import { withTranslation } from 'react-i18next';
import {BllinkLogger} from '../../common/utils/bllink_loggers';

import './autocomplete.css'

class Autocomplete extends Parent {

    constructor(props) {
        super(props);
        this.searchRef = React.createRef();
    }

    handleScriptLoad() {
        const input = this.searchRef.current;
        if (input == null){
            BllinkLogger.error(`couldn't find the address component to init`)
            return;
        }

        this.autocomplete = new window.google.maps.places.Autocomplete(input, {
            fields: ['address_components', 'geometry', 'icon', 'name', 'place_id'], // Set the data fields to return when the user selects a place.
            componentRestrictions: { country: 'IL' }, // TODO: set it to ['IL', 'MX']
        });
        this.autocomplete.addListener('place_changed', () => this.handlePlaceChanged());
    }

    handlePlaceChanged() {
        const raw = this.searchRef.current.value;
        const place = this.autocomplete.getPlace();
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            this.props.onLocationChanged?.({ raw });
        } else {
            BllinkLogger.info('place', place);
            BllinkLogger.info(`lat ${place.geometry.location.lat()} and lng ${place.geometry.location.lng()}`);
            this.props.onPlaceSelected?.(place);
            this.props.onLocationChanged?.(this.placeToLocation(place, raw));
        }
    }

    /**
     * @param {Event<HTMLInputElement>} e
     * */
    handleInputChange(e) {
        this.props.onLocationChanged?.({ raw: e.target.value });
    }

    /**
     * @return {LocationSearch}
     * */
    placeToLocation(place, raw) {
        return place.address_components.reduce((acc, component) => {
            if (component.types.includes('route')) {
                acc.street = component.long_name;
            } else if (component.types.includes('street_number')) {
                acc.streetNumber = component.long_name;
            } else if (component.types.includes('country')) {
                acc.country = component.long_name;
            } else if (component.types.includes('locality')) {
                acc.city = component.long_name;
            }
            return acc;
        }, { raw, name: place.name });
    }

    componentDidMount() {
        if (!window.google) {
            const key = this.googleSettings.autocompleteKey;
            const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=he`;
            this.loadScript(scriptUrl,() => this.handleScriptLoad());
        } else {
            this.handleScriptLoad()
        }
    }

    render() {
        const {t} = this.props;
        return (
            <input
                autoFocus
                ref={this.searchRef}
                name="search"
                id="address"
                className="form-control"
                placeholder={t('search.full_address_placeholder')}
                onChange={(e) => this.handleInputChange(e)}
            />
        )
    }
}

export default withTranslation()(Autocomplete)


